import eventHandler from './utils/eventHandler'

const analyticPlugin = {}

/**
 * install
 *
 * @param {Vue} Vue
 * @param {Object} options
 */
analyticPlugin.install = (Vue, options) => {
  Vue.directive('track-event', {
    bind (el, binding) {
      eventHandler.bind(el, binding)
    }
  })

  Vue.prototype.$ea = trackings
}

const trackings = {
  trackEvent: eventHandler.trackEvent,
  trackPageView: eventHandler.trackPageView,
  affiliateInfo: eventHandler.affiliateInfo
}

export default analyticPlugin
